(<template>
  <div class="form" id="create-user-form">
    <h1 v-translate>Add new user</h1>
    <el-form :model="userForm"
             :rules="rules"
             status-icon
             ref="userForm"
             label-position="left"
             label-width="12em">
      <el-form-item prop="username">
        <span slot="label" v-translate>Username</span>
        <el-input id="input-username" v-model="userForm.username"></el-input>
      </el-form-item>
      <el-form-item prop="email">
        <span slot="label" v-translate>Email</span>
        <el-input id="input-email" type="email" v-model="userForm.email"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <span slot="label" v-translate>Password</span>
        <el-input id="input-password" :type="password.type" v-model="userForm.password">
          <el-button slot="append" :icon="password.icon" @click="showPassword"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item prop="role">
        <span slot="label" v-translate>Role</span>
        <el-select id="input-role" v-model="userForm.role" placeholder="">
          <el-option v-for="item in ['admin', 'TI User']" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button id="button-create-user" type="primary" @click="submitForm('userForm')">
          <span v-translate>Create</span>
        </el-button>
        <el-button id="button-reset-user-form" type="warning" @click="resetForm('userForm')">
          <span v-translate>Reset</span>
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>)

(<script>
import axios from 'axios'

export default {
  name: 'create-user-form',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$session.exists()) {
        if (vm.$session.get('role') === 'admin') {
          next()
        } else {
          this.$message({
            type: 'warning',
            message: this.$gettext('Please sign out and sign in as an admin!')
          })
          next('/')
        }
      } else {
        next('/signin')
      }
    })
  },
  data () {
    return {
      validEmail: false,
      validUsername: false,
      password: {
        visible: false,
        type: 'password',
        icon: 'el-icon-fa-eye'
      },
      userForm: {
        username: '',
        email: '',
        password: '',
        role: ''
      },
      rules: {
        username: [
          {
            type: 'string',
            required: true,
            trigger: 'blur',
            message: this.$gettext('Please enter username')
          },
          {
            validator: this.validateUsername,
            trigger: 'blur'
          }
        ],
        email: [
          {
            type: 'email',
            required: true,
            trigger: 'blur',
            message: this.$gettext('The email is not valid')
          },
          {
            validator: this.validateEmail,
            trigger: 'blur'
          }
        ],
        password: [
          {
            type: 'string',
            required: true,
            trigger: 'blur',
            message: this.$gettext('Please enter password')
          }, {
            min: 5,
            message: this.$gettext('Length should be min 5 characters'),
            trigger: 'blur'
          }
        ],
        role: {
          type: 'string',
          required: true,
          message: this.$gettext('Please select role')
        }
      }
    }
  },
  methods: {
    showPassword () {
      if (!this.password.visible) {
        this.password.type = 'text'
        this.password.icon = 'el-icon-fa-eye-slash'
        this.password.visible = true
      } else {
        this.password.type = 'password'
        this.password.icon = 'el-icon-fa-eye'
        this.password.visible = false
      }
    },
    uploadForm () {
      axios({
        method: 'post',
        url: `${process.env.SERVER_URL}/users`,
        headers: {'Content-Type': 'application/json'},
        data: this.userForm,
        withCredentials: true
      })
      .then(response => {
        this.$message({
          type: 'success',
          message: response.data || 'Upload has completed'
        })
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.uploadForm()
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    validateEmail (rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$gettext('Please enter email')))
      } else {
        axios({
          method: 'get',
          url: `${process.env.SERVER_URL}/users/email/${this.userForm.email}`
        })
        .then(response => {
          if (response.data.exist) {
            callback(new Error(this.$gettext('Email already exists in the database')))
          } else {
            callback()
          }
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          callback(new Error(msg))
        })
      }
    },
    validateUsername (rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$gettext('Please enter username')))
      } else {
        axios({
          method: 'get',
          url: `${process.env.SERVER_URL}/users/username/${this.userForm.username}`
        })
        .then(response => {
          if (response.data.exist) {
            callback(new Error(this.$gettext('Username already exists in the database')))
          } else {
            callback()
          }
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          callback(new Error(msg))
        })
      }
    }
  }
}
</script>)



// WEBPACK FOOTER //
// src/components/Create-User-Form.vue